<template>
       <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Tema 4: Dimensiones del desarrollo desde la perspectiva cultural">
                <div class="container-fluid margen_principal">
                    <div class="row mb-3">
                        <div class="col-xl-5 col-lg-5 col-12">
                            <h2>4. Dimensiones del desarrollo desde la perspectiva cultural</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-12">
                           <p>A modo de cierre, en este apartado se explorarán las diferentes nociones de desarrollo desde una mirada holística, con el fin de identificar las diversas dimensiones que han de considerarse en el desarrollo humano desde la perspectiva de los niños y niñas. En este sentido, se delimitarán las dimensiones corpórea, socioemocional, cognitiva, comunicativa, y estética. Estos criterios se han generado desde un enfoque multidisciplinar que recoge la psicología, la sociología, la biología, la lingüística, la economía, etc. En principio, se parte de la definición de “desarrollo humano” que sugieren Amar, J., Abello, R. y Tirado, D. (2007) como el proceso por el cual “el ser biológico trasciende hacia el ser social y cultural” (p. 3). Este enfoque es centrado en el ser humano como actor de su desarrollo, quien busca múltiples dimensiones, estas son:</p>
                        </div>
                        <div class="col-lg-6 col-xl-6 col-sm-12 col-md-12 col-12">
                           <h6 class="font-italic text-center mb-4">Haga clic en los números para conocer las dimensiones.</h6>
                            <b-card no-body class="tabs mb-3">
                                <b-tabs class="cabeceraTabs">
                                    <b-tab no-body class="p-3 navTab" title="1">
                                        <h5>Dimensión corpórea</h5>
                                        <p class="p-0 m-0">Identifica el ser humano bajo el determinismo biológico, por cuanto comprende que está regido por unas leyes que son generales para la especie, como la reproducción, el crecimiento y la nutrición. Esta dimensión se centra en establecer las condiciones biológicas que hacen posible la vida y su permanencia, como la garantía del correcto funcionamiento del cuerpo. </p>
                                    </b-tab>

                                    <b-tab no-body class="p-3" title="2">
                                        <h5>Dimensión socioemocional</h5>
                                        <p class="p-0 m-0">Sumada a los constituyentes biológicos, se considera que esta dimensión estudia los aspectos emocionales de la especie, la relación del cerebro con el ambiente y las respuestas que generan los individuos de acuerdo a las condiciones en las cuales se encuentran vinculados.</p>
                                    </b-tab>

                                    <b-tab no-body class="p-3" title="3">
                                        <h5>Dimensión cognitiva</h5>
                                        <p class="p-0 m-0">Como se estudió ampliamente en los apartados anteriores, aquí se exploran las formas de representación, organización del pensamiento y construcción del conocimiento que se llevan a cabo en las etapas del desarrollo. </p>
                                    </b-tab>

                                     <b-tab no-body class="p-3" title="4">
                                         <h5>Dimensión comunicativa</h5>
                                        <p class="p-0 m-0">Explora las situaciones comunicativas en las cuales los individuos se encuentran inmersos; también, analiza los intercambios lingüísticos y los problemas de comunicación como los malentendidos. </p>
                                    </b-tab>

                                     <b-tab no-body class="p-3" title="5">
                                         <h5>Dimensión estética</h5>
                                        <p class="p-0 m-0">Se identifica como la capacidad de representación y goce con que cuentan los individuos a la hora de caracterizar el perfil de un objeto de deseo en específico, en función de lo que se puede considerar bello.</p>
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-12 offset-xl-3 offset-lg-3">
                            <div class="row mt-3 cuadroGAVI ml-lg-4">                       
                                <div class="col-lg-3 col-md-3 col-sm-12 col-12 align-items-center d-flex justify-content-center">
                                    <img src="recursos/img/GAVI/Observa_que.png" alt="" class="img-fluid">
                                </div>
                                <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                                    <p class="tal">¿Sabías que…?</p>
                                    <p>Puedes conocer más sobre investigaciones que analizan la relación del cerebro y lenguaje.</p>
                                    <p>En España existe el centro de investigación <i>Basquet Center of Cognition Brain and Languaje.</i>  Allí, en su página, puedes encontrar investigaciones de última generación sobre desarrollo, el lenguaje y el cerebro; además, puedes participar de sus estudios.</p>
                                    <p class="text-center"><span class="url"><a href="https://www.bcbl.eu/es" target="_blank">https://www.bcbl.eu/es</a></span></p>
                                </div>
							</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'Tema4',
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>